export default "__VITE_ASSET__iXDTHi0S__"